import { useMemo } from 'react';
import { useSourceAccountsQuery } from '../../api/useSourceAccountsQuery';
import { OwnerModelDTO } from '../../../../../../../../../Profile/Accounts/api/useAccountsQuery';

interface Params {
  year: number | null;
  accountOwner: string | null;
  ownerModel: OwnerModelDTO[] | null;
  fpId: string;
  isAnnuityQualified: boolean;
  isApplied: boolean;
}

export const usePurchaseAmountForm = ({
  year,
  accountOwner,
  ownerModel,
  fpId,
  isAnnuityQualified,
  isApplied,
}: Params) => {
  const queryResult = useSourceAccountsQuery({
    year,
    fpId,
    accountOwner: ownerModel?.length ? ownerModel[0].Name : accountOwner, // Annuity has single owner
    isApplied,
  });

  const data = useMemo(() => {
    if (!queryResult.data) {
      return {
        accountOptions: [],
        sourceAccounts: [],
      };
    }

    const { SourcesForNonQualifiedAnnuities, SourcesForQualifiedAnnuities } = queryResult.data;

    const sourceAccounts = isAnnuityQualified
      ? SourcesForQualifiedAnnuities
      : SourcesForNonQualifiedAnnuities;

    return {
      sourceAccounts,
      accountOptions: sourceAccounts.map(source => ({
        label: source.Name,
        value: source.Id,
        metaData: {
          SimulatedAccountType: source.SimulatedAccountType,
          IsSimulatedSource: source.IsSimulatedSource,
          EntityId: source.EntityId,
        },
      })),
    };
  }, [isAnnuityQualified, queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
